import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCinemographHero = styled.div`
  .vjs-poster img {
    object-fit: cover !important;
  }

  .loader-cinemograph {
    width: 100%;
    height: auto !important;
    margin-top: ${toRem(-52)};
    position: relative;

    &-tall {
      aspect-ratio: 2/3;

      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 16/9;
        margin-top: ${toRem(-88)};
      }
    }

    &-short {
      aspect-ratio: 1/1;
      padding-top: 0 !important;

      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 16/9;
        margin-top: ${toRem(-88)};
      }

      @media ${baseVariables.mediaQuery.lg} {
        aspect-ratio: 5/2;
      }
    }

    &-image {
      width: 100%;
      margin-top: 0;
      aspect-ratio: 1/1;
      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 3/1;
      }
    }

    .cinemograph-loading-logo {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      &::before {
        font-size: ${toRem(64)};
      }

      &.animate-logo {
        opacity: 0.05;
        transition: 2s;
        transition-delay: 1s;
      }
    }
  }

  [class^='vjs-']::before {
    font-family: 'VideoJS';
  }

  .vjs-title-bar,
  .vjs-big-play-button {
    display: none !important;
  }

  .vjs-control-bar {
    position: absolute;
    z-index: 9;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    /* keep settings/quality controls visible on iOS mobile & tablet (BrowserStack) */
    overflow: visible;
    font-size: ${baseVariables.font['fontXs']};

    .vjs-control:not(.vjs-progress-control):not(.vjs-volume-panel) {
      width: ${toRem(38)};
      flex-shrink: 1;

      @media only ${baseVariables.mediaQuery.sm} {
        width: ${toRem(48)};
        font-size: unset;
      }
    }

    .vjs-quality-menu-wrapper {
      flex-shrink: 0;
    }
    .vjs-subs-caps-button {
      display: block !important;
    }

    .vjs-current-time,
    .vjs-time-divider,
    .vjs-duration {
      display: flex !important;
      width: auto;
      flex-shrink: 0;
      white-space: nowrap;
    }

    /* @noflip */
    .vjs-progress-control {
      position: absolute;
      left: 0;
      right: 0;
      top: ${toRem(-4.19)};
      width: 100%;
      height: ${toRem(4.19)};
      direction: ltr;

      .vjs-progress-holder {
        width: 100%;
      }

      .vjs-play-progress {
        background: ${baseVariables.color['base20']};
      }
    }

    &.cinemograph-vjs-control-bar--rtl {
      flex-direction: row-reverse;
      .vjs-play-control {
        z-index: 11;
      }
    }

    .vjs-volume-level {
      background: ${baseVariables.color['base20']};
    }
    .vjs-menu .vjs-menu-item.vjs-selected {
      background: ${baseVariables.color['base20']};
      .vjs-menu-item-text {
        color: ${baseVariables.color['base10']};
      }
    }
  }

  .vjs-modal-dialog {
    margin-top: ${toRem(52)};
    @media only ${baseVariables.mediaQuery.md} {
      margin-top: ${toRem(88)};
    }
  }

  .cinemograph-image-short {
    width: 100%;
    aspect-ratio: 1/1;
    @media only ${baseVariables.mediaQuery.md} {
      aspect-ratio: 16/9;
    }
    @media ${baseVariables.mediaQuery.lg} {
      aspect-ratio: 5/2;
    }
  }

  .cinemograph-image-tall {
    width: 100%;
    aspect-ratio: 2/3;
    @media only ${baseVariables.mediaQuery.md} {
      aspect-ratio: 16/9;
    }
  }

  .cinemograph-tall {
    .video-js {
      width: 100%;
      aspect-ratio: 2/3;
      height: auto !important;
      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 16/9;
      }
    }
  }

  .cinemograph-short {
    .video-js {
      width: 100%;
      aspect-ratio: 1/1;
      height: auto !important;
      padding-top: 0 !important;

      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 16/9;
      }

      @media ${baseVariables.mediaQuery.lg} {
        aspect-ratio: 5/2;
      }
    }
  }

  .dark-video-control {
    color: ${baseVariables.color['merch30']};
  }

  svg {
    position: absolute;
    top: ${toRem(80)};
    right: ${toRem(24)};
    @media ${baseVariables.mediaQuery['md']} {
      top: ${toRem(112)};
    }
    height: ${toRem(48)};
    width: ${toRem(48)};
  }

  .video-overlay {
    margin-top: ${toRem(-52)};
    @media ${baseVariables.mediaQuery.md} {
      margin-top: ${toRem(-88)};
    }
  }

  .video-container {
    padding: 0;
    position: relative;
    .video-js {
      height: 100vw;
      padding-top: 0;
      overflow: hidden;
      .vjs-tech {
        object-fit: cover;
      }
      .vjs-text-track-display {
        min-height: ${toRem(32)};
        position: absolute;
        bottom: ${toRem(8)};
        left: 0;
        right: 0;
        inset-block: ${toRem(56)} !important;
      }
    }

    @media ${baseVariables.mediaQuery.md} {
      .video-js {
        height: 56.25vw;
        padding-top: 56.25%;
        .vjs-tech {
          object-fit: cover;
        }

        .vjs-text-track-display {
          bottom: calc(${toRem(48)} + ${toRem(8)});
          inset-block: unset;
        }
      }
    }
  }

  .cinemograph--scrim-component {
    background: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50%;
    pointer-events: none;
  }

  .icon-play-pause {
    position: absolute;
    top: ${toRem(52)};
    right: 0;

    @media ${baseVariables.mediaQuery.md} {
      top: ${toRem(112)};
      right: ${toRem(24)};
    }
    width: ${toRem(80)};
    height: ${toRem(80)};
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      opacity: 0.62;
      height: ${toRem(48)};
      width: ${toRem(48)};
      background: ${baseVariables.color['base10']};
      color: ${baseVariables.color['base20']};
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        opacity: 1;
        transition: 0.5s;
      }
    }
  }
  .overlay_text {
    position: absolute;
    bottom: ${toRem(80)};
    right: ${toRem(24)};
    z-index: 10;
    background: ${baseVariables.color['merch30']};
    opacity: 0.54;
  }

  /* AR: html[dir=rtl] + stylis-plugin-rtl can override progress direction in styled CSS */
  [dir='rtl'] & .video-container {
    /* @noflip */
    .vjs-progress-control,
    .vjs-progress-holder,
    .vjs-play-progress {
      direction: ltr !important;
      unicode-bidi: isolate;
    }

    /* @noflip */
    .vjs-play-progress .vjs-time-tooltip {
      right: ${toRem(-24)} !important;
      left: auto !important;
    }
  }
`;
